<div class="evida-info-message box flex flex-col w-full px-medium py-medium bg-green body">
    <span class="text-white font-bold sm:font-normal" [innerHTML]="hint | translate"></span>
</div>
